namespace SP {
    export enum PickOrderPreference {
        ExpirationDate = 0,
        AllSameLocation = 1,
        Closest = 2,
        FirstArrived = 3,
        SmallestStockQuantity = 4,
        BiggestStockQuantity = 5,
        BottomPickFirst = 6,
        TopPickFirst = 7,
        PlacementPickPriority = 8,
        ExactStockQuantity = 9,
        NonRefillLocation = 10,
        RefillLocation = 11
    }
}